import React from 'react';
import { SummaryUsage } from '../services/BillingService';
import { personalakteStyles as ps, colors } from '../../employees/styles/personalakteStyles';

interface UsageOverviewProps {
  usage: SummaryUsage;
}

function progressColor(ratio: number): string {
  if (ratio > 0.9) return colors.danger;
  if (ratio > 0.75) return colors.warning;
  return colors.success;
}

function ProgressBar({ used, total }: { used: number; total: number }): React.JSX.Element {
  const ratio = total > 0 ? used / total : 0;
  const barColor = progressColor(ratio);

  return (
    <div style={{ height: 8, borderRadius: 4, background: colors.bgMuted, overflow: 'hidden', marginTop: 10 }}>
      <div
        style={{
          height: '100%', borderRadius: 4, background: barColor,
          width: `${Math.min(ratio * 100, 100)}%`, transition: 'width 0.3s ease',
        }}
      />
    </div>
  );
}

export default function UsageOverview({ usage }: UsageOverviewProps): React.JSX.Element {
  const kpiCards = [
    {
      label: 'Standorte',
      used: usage.locations_count,
      total: usage.subscribed_locations,
      suffix: 'genutzt / gebucht',
      showProgress: true,
    },
    {
      label: 'Aktive Mitarbeitende',
      used: usage.active_employees_count,
      total: usage.max_employees,
      suffix: `genutzt / inklusive (${usage.employees_utilization_percent}%)`,
      showProgress: true,
    },
  ];

  return (
    <div style={{ marginBottom: 28 }}>
      <div style={ps.sectionHeader}>
        <div style={ps.sectionDot(colors.magenta)} />
        Nutzungsübersicht
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginBottom: 8 }}>
        {kpiCards.map((kpi) => (
          <div key={kpi.label} style={ps.cardCompact}>
            <div style={ps.kpiLabel}>{kpi.label}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
              <span style={ps.kpiValue}>{kpi.used}</span>
              <span style={{ fontSize: 16, fontWeight: 500, color: colors.textMuted }}>/ {kpi.total}</span>
            </div>
            <div style={{ fontSize: 12, color: colors.textLight }}>{kpi.suffix}</div>
            {kpi.showProgress && <ProgressBar used={kpi.used} total={kpi.total} />}
          </div>
        ))}
      </div>

      <div style={{ fontSize: 12, color: colors.textLight, fontStyle: 'italic', paddingLeft: 2 }}>
        Mitarbeitenden-Kontingente sind tenant-weit gepoolt
      </div>
    </div>
  );
}
